export default __webpack_public_path__ + "static/media/cajun.d712fa25.webp";